import { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Button, ButtonLink, FormBox, PageActions } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import { usePageHeader } from "@components/ow";
import { FormPage, focusFirstError } from "../../Common/FormPage";
import { ProjectFields, projectPayload, validateProject } from "./ProjectFields";

// Cadastro de projeto (modelo Formulário do DS OneWork). Ao criar, abre o detalhe
// do projeto novo, onde se incluem os prestadores.

const LIST_HREF = "/c/projects";

export default function NewProject() {
  const projectService = useService("projects");
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", erpCode: "", startDate: "", endDate: "" });
  const [saving, setSaving] = useState(false);
  // Os erros aparecem nos campos depois da primeira tentativa e se atualizam a cada mudança
  const [submitted, setSubmitted] = useState(false);

  usePageHeader({
    title: "Novo projeto",
    breadcrumb: [
      { page: "Projetos", route: LIST_HREF },
      { page: "Novo projeto", route: `${LIST_HREF}/new` },
    ],
  });

  const fieldErrors = submitted ? validateProject(values) : {};

  async function handleSubmit() {
    setSubmitted(true);
    const errors = validateProject(values);
    if (Object.keys(errors).length) {
      focusFirstError(Object.keys(errors));
      return;
    }

    setSaving(true);
    // Em erro, o service já mostra o toast com a mensagem do back e devolve { error: true }
    const result = await projectService.create(projectPayload(values));
    setSaving(false);
    if (!result || result.error) return;

    toast.success("Projeto criado com sucesso");
    const id = result.data?.data?.id;
    navigate(id ? `${LIST_HREF}/${id}` : LIST_HREF);
  }

  return (
    <FormPage
      actions={
        <PageActions>
          <ButtonLink $text="Cancelar" $action={() => navigate(LIST_HREF)} />
          <Button $text="Criar projeto" $variant="primary" $action={handleSubmit} $isLoading={saving} />
        </PageActions>
      }
    >
      <FormBox title="Dados do projeto">
        <ProjectFields
          values={values}
          errors={fieldErrors}
          onChange={(field, value) => setValues((prev) => ({ ...prev, [field]: value }))}
        />
      </FormBox>
    </FormPage>
  );
}
